// extracted by mini-css-extract-plugin
module.exports = {"inboxButton":"styles_inboxButton__liVUu","unreadBadge":"styles_unreadBadge__1g9-X","modalContent":"styles_modalContent__3TjRX","modal":"styles_modal__3vgMg"};